<template>
  <no-auth-layout class="register-page">
    <h2 class="card-title center-align">Rejestracja</h2>
    <p class="card-subtitle center-align">Zarejestruj się jako agent Punkta</p>
    <div class="social-auth-container">
      <div class="line-through-header center-align">
        <span>Zarejestruj się za pomocą:</span>
      </div>
      <div class="row">
        <div class="col s12 m6 offset-m3">
          <button 
            class="btn waves-effect waves-light red lighten-1" 
            id="google"
            @click="authorize('google_oauth2')"
          >
            <i class="mfind-icon mfind-icon-google left"></i>
            <span>Google</span>
          </button>
        </div>
      </div>
    </div>
    <div class="email-auth-container">
      <div class="line-through-header center-align">
        <span>lub przy użyciu <br>adresu email:</span>
      </div>
      <form @submit.prevent="submitRegister()" method="POST">
        <div v-if="data.errors" class="center-align validation-errors">
          <span class="red-text" v-if="data.errors['message']">
            {{ data.errors['message'].join(', ') }}
          </span>
          <span class="red-text" v-else>
            Rejestracja nie była możliwa, uzupełnij lub popraw zaznaczone pola
          </span>
        </div>

        <div class="row">
          <input-field class="col s12 m6" type="text" name="first_name"
            label="Imię" v-model="data.first_name"
            @updateError="val => data.errors['first_name'] = val"
            required="true" :errors="data.errors['first_name']"/>
          <input-field class="col s12 m6" type="text" name="last_name"
            label="Nazwisko" v-model="data.last_name"
            @updateError="val => data.errors['last_name'] = val"
            required="true" :errors="data.errors['last_name']"/>
        </div>

        <input-field type="email" name="email"
          label="Adres e-mail" v-model="data.email"
          @updateError="val => data.errors['email'] = val"
          required="true" :errors="data.errors['email']"/>

        <div class="row">
          <input-field class="col s12 m6" type="password" name="password"
            label="Hasło" v-model="data.password"
            @updateError="val => data.errors['password'] = val"
            required="true" :errors="data.errors['password']"/>
          <input-field class="col s12 m6" type="password" name="password_confirmation"
            label="Powtórz hasło" v-model="data.password_confirmation"
            @updateError="val => data.errors['password_confirmation'] = val"
            required="true" :errors="data.errors['password_confirmation']"/>
        </div>
   
        <input-field hidden v-if="data.parent_mpc_code" name="parent_mpc_code" v-model="data.parent_mpc_code"/>

        <div class="row col">
          Administratorem podanych danych osobowych będzie punkta sp. z o.o. Dane będą przetwarzane w celu zawarcia i
          wykonania umowy uczestnictwa w programie partnerskim punkta.pl na zasadach określonych w
          <a class="rules" href="https://punkta.pl/regulaminy/#regulamin-programu-partnerskiego-punkta-autoopen" target="_blank">Regulaminie</a>.
          Czytaj więcej w
          <a class="rules"
             href="https://punkta.pl/regulaminy/#polityka-prywatnosci-autoopen"
             target="_blank">Polityce prywatności</a>.
        </div>

        <button class="btn-large z-depth-0" type="submit">Zarejestruj się</button>
      </form>
    </div>
    <br>
    <div class="card-footer">
      Masz już konto? <router-link :to="{ name: 'login' }">Zaloguj się</router-link>
    </div>
    <Loader :loading="data.loading"/>
  </no-auth-layout>
</template>


<script>
import NoAuthLayout from '@/layouts/noAuthLayout'
import InputField from '@/components/inputs/text'
import Loader from '@/components/loader'
export default {
  name: 'register',
  components: { NoAuthLayout, InputField, Loader },
  data () {
    return {
      data: {
        loading: false,
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        errors: false,
        parent_mpc_code: this.$route.query.parent_mpc_code
      }
    }
  },
  beforeCreate () {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push({ name: 'dashboard' })
    }
  },
  methods: {
    authorize (provider) {
      this.data.loading = true
      this.$store.dispatch('authSocial', { provider, isBroker: true, parentMpcCode: this.$route.query.parent_mpc_code })
        .then(
          response => {
            this.data.loading = false
            this.$router.push({ name: 'dashboard' })
          },
          errorResponse => { this.data.loading = false }
        )
    },
    submitRegister () {
      this.data.loading = true
      this.$store.dispatch('register', {
        first_name: this.data.first_name,
        last_name: this.data.last_name,
        email: this.data.email,
        password: this.data.password,
        password_confirmation: this.data.password_confirmation,
        punkta_agent: true,
        parent_mpc_code: this.data.parent_mpc_code
      })
      .then(
        response => {
          this.data.loading = false
          if (response.code === 200) {
            this.$router.push({ name: 'checkInbox' })
          }
        },
        errorResponse => {
          this.data.loading = false
          this.data.errors = errorResponse.errors
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// registerAgent.vue?bec4e8ee